import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { IconComponent } from '@ui-components/components/icon/icon.component';

import { InfoModalComponent } from './info-modal.component';

@NgModule({
  declarations: [InfoModalComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, IconComponent],
  exports: [InfoModalComponent],
})
export class InfoModalModule {}
